import React from 'react';
import { EyeOff, Lock, Clock } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-10 bg-alt" data-id="element-172">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-serif text-title mb-6" data-id="element-175">
            Si te frena la exposición, no es falta de capacidad: es falta de
            método.
          </h2>
          <p className="text-lg text-body leading-relaxed mb-3" data-id="element-176">
            Ves a otras personas creciendo en redes y piensas: "Eso no es para
            mí".
          </p>
          <p className="text-lg text-body leading-relaxed" data-id="element-177">
            No por falta de ganas. Sino porque no quieres exponerte.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-178">
          <div className="bg-card p-8 border border-[#D9D0C1] hover:border-accent transition-colors duration-300" data-id="element-179">
            <div className="w-12 h-12 bg-main rounded-full flex items-center justify-center mb-6 text-accent" data-id="element-180">
              <EyeOff size={24} data-id="element-181" />
            </div>
            <h3 className="text-xl font-serif mb-3 text-title" data-id="element-182">
              Miedo al qué dirán
            </h3>
            <p className="text-body text-sm leading-relaxed" data-id="element-183">
              No quieres que tu jefe, amigas o familia te vean en redes. Quieres
              ingresos extra, no explicaciones.
            </p>
          </div>

          <div className="bg-card p-8 border border-[#D9D0C1] hover:border-accent transition-colors duration-300" data-id="element-184">
            <div className="w-12 h-12 bg-main rounded-full flex items-center justify-center mb-6 text-accent" data-id="element-185">
              <Lock size={24} data-id="element-186" />
            </div>
            <h3 className="text-xl font-serif mb-3 text-title" data-id="element-187">
              Privacidad ante todo
            </h3>
            <p className="text-body text-sm leading-relaxed" data-id="element-188">
              No vas a enseñar tu casa, tus hijos ni tu vida personal para
              vender. Punto.
            </p>
          </div>

          <div className="bg-card p-8 border border-[#D9D0C1] hover:border-accent transition-colors duration-300" data-id="element-189">
            <div className="w-12 h-12 bg-main rounded-full flex items-center justify-center mb-6 text-accent" data-id="element-190">
              <Clock size={24} data-id="element-191" />
            </div>
            <h3 className="text-xl font-serif mb-3 text-title" data-id="element-192">
              Falta de tiempo (y energía)
            </h3>
            <p className="text-body text-sm leading-relaxed" data-id="element-193">
              Entre trabajo, casa y vida, no puedes dedicar horas a grabar y
              editar. Necesitas un sistema simple que puedas sostener.
            </p>
          </div>
        </div>
      </div>
    </section>;
}